import PageLayer from "@/Layouts/views/PageLayer";
import UserPreferencesContainer from "@/User/components/UserPreferences/UserPreferencesContainer";
import Icon from "@/User/assets/icons/UserPreferences.svg";

export default function UserPreferences() {
	return (
		<PageLayer title="User Preferences" icon={Icon}>
			<UserPreferencesContainer />
		</PageLayer>
	);
}
